export const isNumberValidation = value =>
  Number.isNaN(+value) ? 'Invalid number' : undefined;

export const isPositiveNumberValidation = value =>
  +value > 0 ? undefined : 'Must be a positive number';

export default { isNumberValidation, isPositiveNumberValidation };
